import React from "react";
import ActivityModule from "@/components/ActivityModule";
import { PageHeader } from "@/components/shared";

export default function SEO() {
  return (
    <div>
      <PageHeader title="SEO" subtitle="Log ranking, backlink, technical & content activities — organic KPIs auto-calculate" />
      <ActivityModule module="seo" />
    </div>
  );
}
